// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  teamUrlRedirect: 'https://dev.totalglobalsports.com/TeamAdmin/Dashboard.aspx?tid=',
  //firebaseConfig: {
  //  //New test
  //  // apiKey: 'AIzaSyC8AmW9X7wTd9h4g_IGlv7FeP2iQ73BXoE',
  //  // authDomain: 'chatapp-7635b.firebaseapp.com',
  //  // databaseURL: 'https://chatapp-7635b-default-rtdb.firebaseio.com',
  //  // projectId: 'chatapp-7635b',
  //  // storageBucket: 'chatapp-7635b.appspot.com',
  //  // messagingSenderId: '379428171433',
  //  // appId: '1:379428171433:web:fd2336ee8ca91d497543b8'

  //  //Test
  //  // apiKey: 'AIzaSyDluIg5Q_gPGQDOUvkDeE3BUuHZYSpNS9s',
  //  // authDomain: 'angularchatdemo-19419.firebaseapp.com',
  //  // databaseURL: 'https://angularchatdemo-19419-default-rtdb.firebaseio.com',
  //  // projectId: 'angularchatdemo-19419',
  //  // storageBucket: 'angularchatdemo-19419.appspot.com',
  //  // messagingSenderId: '850285669243',
  //  // appId: '1:850285669243:web:0100e5be5284fe4c89abde'

  //  //TGS
  //  apiKey: 'AIzaSyCrFY0b3twNc0s6f3iu3K-NRWZl12W28_U',
  //  authDomain: 'tgs-club-app.firebaseapp.com',
  //  databaseURL: 'https://tgs-club-app-default-rtdb.firebaseio.com',
  //  projectId: 'tgs-club-app',
  //  storageBucket: 'tgs-club-app.appspot.com',
  //  messagingSenderId: '159170957833',
  //  appId: '1:159170957833:web:7da80140e4d044c4811ed8',
  //  measurementId: 'G-S8P3ZNVB2F'

  //},
  secretKey: 'secreme_key'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts